import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import { CreateDealerModal } from "./CreateDealerModal";

const fabStyle = {
  position: "absolute",
  top: 80,
  right: 16,
};
export function CreateDealerFab() {
  const [show, setShow] = useState(false);
  return (
    <>
      <Fab
        size="small"
        color="primary"
        aria-label="add"
        sx={fabStyle}
        onClick={() => setShow(true)}
      >
        <AddIcon />
      </Fab>
      <CreateDealerModal onClose={() => setShow(false)} open={show} />
    </>
  );
}
